<template>
  <b-list-group-item>
    <div>
      <div class="text-primary font-weight-bold">
        {{ labelText }}
      </div>
      <div>{{ valueText? valueText : '-' }}</div>
    </div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'ListItem',
  components: {
    BListGroupItem,
  },
  props: {
    labelText: {
      type: String,
      required: true,
    },
    valueText: {
      type: String,
      required: true,
    },
  },
}
</script>
